import React, { useState } from 'react';
import { MapPin, ArrowRight, ChevronLeft, ChevronRight, X, Maximize2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const isYouTubeUrl = (url: string) => {
  return url.includes('youtube.com') || url.includes('youtu.be');
};

const getYouTubeEmbedUrl = (url: string) => {
  let videoId = '';
  if (url.includes('/shorts/')) {
    videoId = url.split('/shorts/')[1]?.split('?')[0] || '';
  } else if (url.includes('v=')) {
    videoId = url.split('v=')[1]?.split('&')[0] || '';
  } else if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1]?.split('?')[0] || '';
  } else if (url.includes('/embed/')) {
    return url;
  }
  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

const Developments: React.FC = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState<any | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomedMedia, setZoomedMedia] = useState<{ url: string; type: string } | null>(null);
  // const videoRef = React.useRef<HTMLVideoElement>(null);




  const projects = [
    {
      id: 1,
      title: "Ursula",
      location: "Aurora, CO",
      status: "Completed",
      price: "$420K",
      completionDate: "November 2025",
      beforeImage: "/assets/pics/ursula/before/b3.jpeg",
      afterImage: "/assets/pics/ursula/after/a0.jpg",
      description: "A beautiful townhouse that showcases the perfect blend of historic charm and modern comfort in Aurora.",
      features: ["4 Bedrooms", "3 Bathrooms", "2,156 sq ft", "Garden", "Original Woodwork on wall"],
      investmentReturn: "14%",
      media: [
        { url: "/assets/pics/ursula/after/a0.jpg", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a1.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a2.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a3.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a4.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a5.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a7.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a8.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a9.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a11.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a12.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a14.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a15.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a16.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a17.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a18.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a19.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a20.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a21.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a23.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a25.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a26.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a28.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a29.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a30.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a31.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a32.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a34.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a35.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a36.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a37.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a38.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a39.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a40.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a41.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a42.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a43.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a44.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a45.webp", type: "image", label: "After" },
        { url: "/assets/pics/ursula/after/a46.webp", type: "image", label: "After" },
        { url: "/assets/vids/ursula/after/a1.mp4", type: "video", label: "After" },
        { url: "/assets/vids/ursula/after/a2.mp4", type: "video", label: "After" },
        { url: "/assets/pics/ursula/before/b1.jpeg", type: "image", label: "Before" },
        { url: "https://www.youtube.com/shorts/1y00GxctI5I", type: "video", label: "Before" },
        { url: "/assets/pics/ursula/before/b2.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/ursula/before/b3.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/ursula/before/b4.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/ursula/before/b5.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/ursula/before/b6.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/ursula/before/b7.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/ursula/before/b8.jpeg", type: "image", label: "Before" }
      ]
    },
    {
      id: 2,
      title: "Chautauga Mountain",
      location: "Littleton, CO",
      status: "Completed",
      price: "$875K",
      completionDate: "March  2026",
      beforeImage: "/assets/pics/chautauga/before/b1.webp",
      afterImage: "/assets/pics/chautauga/after/01-DSC07347.jpg",
      description: "Central location in prime Ken Caryl real estate ,abundance of natural light, an open floor plan, and an oversized primary bedroom suite",
      features: ["5 Bedrooms", "3 Bathrooms", "3704 sf", "Custom Cabinets"],
      investmentReturn: "18%",
      media: [
        { url: "/assets/pics/chautauga/after/01-DSC07347.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/03-DSC07353.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/04-DSC07356.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/05-DSC07359.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/06-DSC07362.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/07-DSC07365.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/09-DSC07371.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/10-DSC07374.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/12-DSC07380.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/13-DSC07383.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/14-DSC07386.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/16-DSC07392.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/17-DSC07395.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/19-DSC07401.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/20-DSC07404.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/21-DSC07407.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/23-DSC07413.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/24-DSC07416.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/25-DSC07419.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/26-DSC07422.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/27-DSC07425.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/28-DSC07428.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/after/29-DSC07431.jpg", type: "image", label: "After" },
        { url: "/assets/pics/chautauga/before/b1.webp", type: "image", label: "Before" },
        { url: "https://www.youtube.com/shorts/hO4yCtqiYpY", type: "video", label: "Before" },
        { url: "/assets/pics/chautauga/before/b2.webp", type: "image", label: "Before" },
        { url: "/assets/pics/chautauga/before/b3.webp", type: "image", label: "Before" },
        { url: "/assets/pics/chautauga/before/b4.webp", type: "image", label: "Before" },
        { url: "/assets/pics/chautauga/before/b5.webp", type: "image", label: "Before" },
        { url: "/assets/pics/chautauga/before/b6.webp", type: "image", label: "Before" },
        { url: "/assets/pics/chautauga/before/b7.webp", type: "image", label: "Before" },
        { url: "/assets/pics/chautauga/before/b8.webp", type: "image", label: "Before" }
      ]
    },
    {
      id: 3,
      title: "Valley Forge Dr",
      location: "Houston, TX",
      status: "Completed",
      price: "$849K",
      completionDate: "March 2026",
      beforeImage: "/assets/pics/valley/before/3.0.jpg",
      afterImage: "/assets/pics/valley/after/a1.jpeg",
      description: "Prime location in Memorial near top-rated Spring Branch schools. Close to CityCentre, Memorial City Mall, and major highways.Quiet, tree-lined neighborhood with high land value and appreciation.Great potential for remodel or new construction investment. Strong community prestige and long-term market stability.",
      features: ["3 Bedrooms", "3 Bathrooms", "2304 sf", "Custom Cabinets"],
      investmentReturn: "9%",
      media: [
        { url: "/assets/pics/valley/after/a1.jpeg", type: "image", label: "After" },
        { url: "https://www.youtube.com/shorts/LqFQS5uaLWk", type: "video", label: "After" },
        { url: "https://www.youtube.com/shorts/Y7cN3Hskiuc", type: "video", label: "After" },
        { url: "/assets/vids/valley/after/a1.MOV", type: "video", label: "After" },
        { url: "/assets/vids/valley/after/a2.MOV", type: "video", label: "After" },
        { url: "/assets/pics/valley/after/a2.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a3.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a4.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a5.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a6.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a7.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a8.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a9.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a10.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a11.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/after/a12.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/valley/before/3.0.jpg", type: "image", label: "Before" },
        { url: "https://www.youtube.com/shorts/_OZ6A0ot12A", type: "video", label: "Before" }
      ]
    },
    {
      id: 4,
      title: "South Circle ",
      location: "Fonderen",
      status: "Completed",
      price: "$749K",
      completionDate: "July 2026",
      beforeImage: "/assets/pics/south_circle/before/b1.jpeg",
      afterImage: "",
      description: "Beautiful home in Lakes of Fondren with Guard on duty. On a Cul-de sac street with no back neighbors. Large back yard with pool and SPA. Deck off of upstairs bedroom over looking pool.",
      features: ["4 Bedrooms", "5 Bathrooms", "3722  sf", "Pool 2 Spacious Living rooms privacy in backyard custom upgrades"],
      investmentReturn: "19%",
      media: [
        { url: "/assets/vids/scircle/a1.mp4", type: "video", label: "After" },
        { url: "/assets/vids/scircle/a2.mp4", type: "video", label: "After" },
        { url: "/assets/pics/south_circle/before/b1.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b3.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b5.JPG", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b6.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b7.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b9.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b11.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b12.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b13.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b17.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b18.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b21.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b22.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b23.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b25.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b27.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b29.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b30.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b31.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b35.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b36.jpg", type: "image", label: "Before" },
        { url: "/assets/pics/south_circle/before/b37.jpg", type: "image", label: "Before" }
      ]
    },
    {
      id: 5,
      title: "Meadowlake",
      location: "Shadybriar",
      status: "Completed",
      price: "$499K",
      completionDate: "June 2026",
      beforeImage: "/assets/pics/meadowlake/before/b1.jpeg",
      afterImage: "/assets/pics/meadowlake/after/a3.0.jpeg",
      description: "Beautiful home with architectural character and effortless livability. Soaring ceilings and spacious backyard and Energy-efficient features include",
      features: ["4 Bedrooms", "2.5 Bathrooms", "2,436 sf"],
      investmentReturn: "14%",
      media: [
        { url: "/assets/pics/meadowlake/after/a3.0.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/after/a3.1.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/after/a3.2.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/after/a3.3.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/after/a3.4.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/after/a8.1.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/after/a9.jpeg", type: "image", label: "After" },
        { url: "/assets/pics/meadowlake/before/b1.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b2.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b3.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b4.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b5.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b6.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b7.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b8.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b9.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b10.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b11.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b12.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b13.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b14.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b15.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b16.jpeg", type: "image", label: "Before" },
        { url: "/assets/pics/meadowlake/before/b17.jpeg", type: "image", label: "Before" }
      ]
    },
  ];

  const filteredProjects = activeFilter === 'all'
    ? projects
    : projects.filter(project => project.status.toLowerCase().includes(activeFilter.toLowerCase()));

  const filters = [
    { key: 'all', label: 'All Projects' },
    { key: 'completed', label: 'Completed' },
    { key: 'in progress', label: 'In Progress' }
  ];

  const pauseAllVideos = () => {
    const videos = document.querySelectorAll('.modal-gallery video');
    videos.forEach((video) => {
      try {
        (video as HTMLVideoElement).pause();
      } catch (e) {
        console.error("Error pausing video:", e);
      }
    });
    const iframes = document.querySelectorAll('.modal-gallery iframe');
    iframes.forEach((iframe) => {
      try {
        const htmlIframe = iframe as HTMLIFrameElement;
        const src = htmlIframe.src;
        htmlIframe.src = src;
      } catch (e) {
        console.error("Error resetting iframe src:", e);
      }
    });
  };

  const closeModal = () => {
    pauseAllVideos();
    setSelectedProject(null);
    setCurrentImageIndex(0);
  };

  const closeZoom = () => {
    setIsZoomed(false);
    setZoomedMedia(null);
  };

  const nextImage = () => {
    pauseAllVideos();
    setCurrentImageIndex((prevIndex) =>
      prevIndex + 1 === (selectedProject?.media.length || 0) ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    pauseAllVideos();
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? (selectedProject?.media.length || 0) - 1 : prevIndex - 1
    );
  };


  const handleMediaClick = (item: any) => {
    setZoomedMedia({ url: item.url, type: item.type });
    setIsZoomed(true);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-r from-dark-gray to-gray-800 text-white">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in-up">
            Our Developments
          </h1>
          <p className="text-xl md:text-2xl text-golden max-w-3xl mx-auto fade-in-up stagger-1">
            Discover our portfolio of restored historic properties and ongoing
            projects.
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="section-padding bg-light-beige">
        <div className="container-custom">
          <div className="flex flex-wrap justify-center gap-4">
            {filters.map((filter, index) => (
              <button
                key={filter.key}
                onClick={() => setActiveFilter(filter.key)}
                className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 hover-lift fade-in-up stagger-${index + 1
                  } ${activeFilter === filter.key
                    ? "bg-golden text-white"
                    : "bg-white text-dark-gray hover:bg-golden hover:text-white"
                  }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-12">
            {filteredProjects.map((project, index) => (
              <div
                key={project.id}
                className={`bg-white rounded-lg shadow-lg overflow-hidden card-hover flex flex-col h-full fade-in-up stagger-${(index % 3) + 1}`}
              >
                {/* Before/After Comparison */}
                <div className="relative">
                  {project.status === 'Completed' && project.afterImage ? (
                    <div className="grid grid-cols-2">
                      <div className="relative">
                        <img
                          src={project.beforeImage}
                          alt={`${project.title} - Before`}
                          className="w-full h-64 object-cover"
                        />
                        <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                          Before
                        </div>
                      </div>
                      <div className="relative">
                        <img
                          src={project.afterImage}
                          alt={`${project.title} - After`}
                          className="w-full h-64 object-cover"
                        />
                        <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                          After
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="relative">
                      <img
                        src={project.beforeImage}
                        alt={`${project.title} - Before`}
                        className="w-full h-64 object-cover"
                      />
                      <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                        Before
                      </div>
                    </div>
                  )}

                  {/* Status Badge */}
                  <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
                    <span
                      className={`px-4 py-2 rounded-full text-sm font-medium ${project.status === 'Completed' ? 'bg-green-500 text-white' : 'bg-golden text-white'
                        }`}
                    >
                      {project.status}
                    </span>
                  </div>
                </div>

                {/* Project Details */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-2xl font-bold text-dark-gray mb-3">{project.title}</h3>

                  <div className="flex items-center text-gray-600 mb-3">
                    <MapPin className="w-4 h-4 mr-2 text-golden" />
                    <span>{project.location}</span>
                  </div>

                  {/* Description */}
                  <p className="text-gray-600 mb-4 line-clamp-3">{project.description}</p>

                  {/* Key Features */}
                  {project.features[0] && (
                    <div className="mb-4">
                      <h4 className="font-semibold text-dark-gray mb-2">Key Features:</h4>
                      <div className="flex flex-wrap gap-2">
                        {project.features.map((feature: string, index: number) => (
                          <span
                            key={index}
                            className="bg-light-beige text-dark-gray px-3 py-1 rounded-full text-sm"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* boşluk bırakıcı */}
                  <div className="flex-grow"></div>

                  {/* Project Stats */}
                  <div className="grid grid-cols-3 gap-4 mb-6 text-center">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-golden">{project.price}</div>
                      <div className="text-sm text-gray-600">Price</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-golden">{project.completionDate}</div>
                      <div className="text-sm text-gray-600">Completion</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-golden">{project.investmentReturn}</div>
                      <div className="text-sm text-gray-600">ROI</div>
                    </div>
                  </div>

                  {/* CTA Button */}
                  <button
                    className="w-full btn-primary flex items-center justify-center hover-lift"
                    onClick={() => setSelectedProject(project)}
                  >
                    View Full Details
                    <ArrowRight className="ml-2" size={20} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Modern Modal */}
      {selectedProject && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div>
                <h2 className="text-3xl font-bold text-dark-gray">{selectedProject.title}</h2>
                <div className="flex items-center text-gray-600 mt-2">
                  <MapPin className="w-4 h-4 mr-2 text-golden" />
                  <span>{selectedProject.location}</span>
                </div>
              </div>
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                onClick={closeModal}
              >
                <X size={24} className="text-gray-600" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
              {/* Horizontal Image Gallery */}
              <div className="relative mb-6">
                <div className="relative overflow-hidden rounded-xl bg-gray-100">
                  <div
                    className="flex transition-transform duration-300 ease-in-out modal-gallery"
                    style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
                  >

                    {selectedProject.media?.map((item: any, index: number) => (
                      <div key={index} className="w-full flex-shrink-0 relative group">
                        {item.type === 'video' ? (
                          isYouTubeUrl(item.url) ? (
                            <iframe
                              src={getYouTubeEmbedUrl(item.url)}
                              className="w-full h-80 bg-black rounded-lg"
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            />
                          ) : (
                            <div className="relative w-full h-80 bg-black rounded-lg overflow-hidden">
                              <video
                                src={item.url}
                                className="w-full h-full object-contain"
                                controls
                              />
                              <button
                                onClick={() => handleMediaClick(item)}
                                className="absolute top-4 right-4 bg-black/60 hover:bg-black/80 text-white p-2 rounded-full transition-all duration-200 opacity-0 group-hover:opacity-100 z-10"
                                title="Zoom Video"
                              >
                                <Maximize2 size={16} />
                              </button>
                            </div>
                          )
                        ) : (
                          <img
                            src={item.url}
                            alt={`${selectedProject.title} - ${item.label}`}
                            className="w-full h-80 object-contain bg-gray-100 cursor-pointer hover:opacity-90 transition-opacity"
                            onClick={() => handleMediaClick(item)}
                          />
                        )}
                        <div className={`absolute top-4 ${item.label === 'Before' ? 'left-4' : 'right-4'}`}>
                          <span className={`px-3 py-1 rounded-full text-sm font-medium ${item.label === 'Before' ? 'bg-red-500 text-white' : 'bg-green-500 text-white'
                            }`}>
                            {item.label}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Navigation Buttons */}
                {selectedProject.media?.length > 1 && (
                  <>
                    <button
                      className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
                      onClick={prevImage}
                    >
                      <ChevronLeft size={20} />
                    </button>
                    <button
                      className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
                      onClick={nextImage}
                    >
                      <ChevronRight size={20} />
                    </button>
                  </>
                )}

                {/* Dots Indicator */}
                {selectedProject.media?.length > 1 && (
                  <div className="flex justify-center mt-4 space-x-2">
                    {selectedProject.media.map((_: any, index: number) => (
                      <button
                        key={index}
                        className={`w-3 h-3 rounded-full transition-all duration-200 ${index === currentImageIndex ? 'bg-golden w-6' : 'bg-gray-300'
                          }`}
                        onClick={() => {
                          pauseAllVideos();
                          setCurrentImageIndex(index);
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* Project Details */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-dark-gray mb-4">Project Overview</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{selectedProject.description}</p>

                  {selectedProject.features[0] && (
                    <div className="mb-6">
                      <h4 className="font-semibold text-dark-gray mb-3">Key Features</h4>
                      <div className="flex flex-wrap gap-2">
                        {selectedProject.features.map((feature: string, index: number) => (
                          <span
                            key={index}
                            className="bg-light-beige text-dark-gray px-3 py-2 rounded-full text-sm font-medium"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  <h3 className="text-2xl font-bold text-dark-gray mb-4">Investment Details</h3>

                  <div className="space-y-4 mb-6">
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600">Status</span>
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${selectedProject.status === 'Completed'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-golden/20 text-golden'
                        }`}>
                        {selectedProject.status}
                      </span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600">Price</span>
                      <span className="text-xl font-bold text-golden">{selectedProject.price}</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600">Completion</span>
                      <span className="font-semibold text-dark-gray">{selectedProject.completionDate}</span>
                    </div>
                    <div className="flex justify-between items-center py-3">
                      <span className="text-gray-600">ROI</span>
                      <span className="text-xl font-bold text-golden">{selectedProject.investmentReturn}</span>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      closeModal();
                      navigate('/contact');
                    }}
                    className="w-full bg-golden text-white py-3 px-6 rounded-lg font-semibold hover:bg-golden/90 transition-colors hover-lift"
                  >
                    Request Investment Package
                    <ArrowRight className="inline ml-2" size={18} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Zoom Modal */}
      {isZoomed && zoomedMedia && (
        <div
          className="fixed inset-0 bg-black/95 flex items-center justify-center z-[60] p-4 cursor-zoom-out"
          onClick={closeZoom}
        >
          <button
            className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors z-10"
            onClick={closeZoom}
          >
            <X size={32} className="text-white" />
          </button>

          {zoomedMedia.type === 'video' ? (
            isYouTubeUrl(zoomedMedia.url) ? (
              <iframe
                src={`${getYouTubeEmbedUrl(zoomedMedia.url)}?autoplay=1`}
                className="w-full max-w-4xl aspect-video bg-black rounded-lg"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <video
                src={zoomedMedia.url}
                className="max-w-full max-h-[90vh] object-contain cursor-auto"
                controls
                autoPlay
                onClick={(e) => e.stopPropagation()}
              />
            )
          ) : (
            <img
              src={zoomedMedia.url}
              alt="Zoomed view"
              className="max-w-full max-h-[90vh] object-contain cursor-auto"
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Developments;